// Carousel Slick
// Created: 04/2018
// Created for: Checkout image carousel
// Required : 
// 			- Revealizr.js

// Accessibility text
var sliderText = {
	prev: 'Diapositive précédente',
	next: 'Diapositive suivante'
};

if (lang === 'en') {
	sliderText = {
		prev: 'Previous slide',
		next: 'Next slide'
	}
}

function carouselSlick() {
	$('[data-module~="carousel-slick"]').not('.slick-initialized').each(function() {
		$(this).carousel_slick({
			dots: eval( $(this).attr('data-has-dots')), // True or False
			itemsPerPage: parseFloat($(this).attr('data-items-per-page')) // Integer
		});
	});
}

function carouselSlickCustomBreakpoints() {
	$('[data-module~="carousel-slick-custom-breakpoints"]').not('.slick-initialized').each(function() {
		$(this).carousel_slick({
			dots: eval( $(this).attr('data-has-dots') ), // True or False
			itemsPerPage: parseFloat($(this).attr('data-items-per-page')), // Integer
			unslickBreakpointMinWidth: ($(this).attr('data-breakpoint-min-width') !== undefined) ? parseFloat(eval($(this).attr('data-breakpoint-min-width'))) : undefined, // Revealizr breakpoint
			unslickBreakpointMaxWidth: ($(this).attr('data-breakpoint-max-width') !== undefined) ? parseFloat(eval($(this).attr('data-breakpoint-max-width'))) : undefined // Revealizr breakpoint
		});
	});
}

function pdpCarouselSlick() {
	$('.pdp-image-slick').not('.slick-initialized').slick({
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		draggable: false,
		swipe: false,
		infinite: false,
		dots: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: true,
					draggable: true,
					swipe: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}

(function ($) {
	'use strict';

	$.fn.carousel_slick = function (options) {

		return this.each(function () {

			// Default settings
			var settings = $.extend({
				dots: false,
				itemsPerPage: 5,
				unslickBreakpointMinWidth: parseFloat (Revealizr.breakpointTabletMaxWidth ),
				unslickBreakpointMaxWidth: undefined,
				draggable: false
			}, options);

			const slider = $(this);
			const slides = slider.find('> *').filter(':visible');
			const slidesTotal = slides.length;

			slider.on('init', function(event, slick){
				injectSVG();

				const slidesToScroll = slick.options.slidesToScroll;
				for (let i = slidesToScroll; i < slidesTotal; i++) {
					$(slick.$slides[i]).css('visibility', 'hidden') ;
				}
			});

			$(this).on('beforeChange', function(event, slick, currentSlide, nextSlide) {
				const slidesToScroll = slick.options.slidesToScroll;
				let beginIndex, endIndex;

				if(currentSlide < nextSlide) { // showing next slides
					beginIndex = currentSlide + slidesToScroll;
					endIndex = Math.min(currentSlide + (2 * slidesToScroll), slidesTotal);
				} else { // showing previous slides
					beginIndex = Math.max(currentSlide - slidesToScroll, 0);
					endIndex = currentSlide;
				}

				for (let i = beginIndex; i < endIndex; i++) {
					$(slick.$slides[i]).css('visibility', 'visible') ;
				}
			});

			$(this).on('afterChange', function(event, slick, currentSlide) {
				const slidesToScroll = slick.options.slidesToScroll;
				if (currentSlide + slidesToScroll >= slidesTotal) {
					$(event.target).find('.slick-next').attr('disabled','disabled');
					$(event.target).find('.slick-prev').removeAttr('disabled');
				} else if(currentSlide === 0) {
					$(event.target).find('.slick-next').removeAttr('disabled');
					$(event.target).find('.slick-prev').attr('disabled','disabled');
				} else {
					$(event.target).find('.slick-next').removeAttr('disabled');
					$(event.target).find('.slick-prev').removeAttr('disabled');
				}

				const beginIndex = Math.max(currentSlide - slidesToScroll, 0);
				const endIndex = Math.min(currentSlide + (2 * slidesToScroll), slidesTotal);

				let pageFirstSlideIndex = currentSlide;
				if(pageFirstSlideIndex + slidesToScroll > slidesTotal) {
					const overflow = pageFirstSlideIndex + slidesToScroll - slidesTotal;
					pageFirstSlideIndex -= overflow;
				}

				for (let i = beginIndex; i < endIndex; i++) {
					if(i < pageFirstSlideIndex || i >= (pageFirstSlideIndex + slidesToScroll)) {
						$(slick.$slides[i]).css('visibility', 'hidden');
					}
				}
			});

			function slickInit() {
				slider.removeClass('carousel-slick-is_disabled');

				slider.slick({
					infinite: false,
					prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
					nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',					dots: settings.dots,
					customPaging: function (slider, i) {
						return $('<button class="slider-dot" type="button" data-role="none" role="button" tabindex="0"><span class="invisible-text">Slide ' + i + '</span></button>');
					},
					appendDots: slider,
					centerMode: false,
					slidesToShow: settings.itemsPerPage,
					slidesToScroll: settings.itemsPerPage,
					draggable: false,
					accessibility: false
				});
			}

			function slickEnabled() {
				if( !slider.hasClass('slick-initialized') && slidesTotal > settings.itemsPerPage && ( settings.unslickBreakpointMaxWidth === undefined && document.body.clientWidth > settings.unslickBreakpointMinWidth || document.body.clientWidth < settings.unslickBreakpointMaxWidth && document.body.clientWidth >= settings.unslickBreakpointMinWidth ) ) {
					slickInit();
				} else if( slider.hasClass('slick-initialized') && ( ( settings.unslickBreakpointMaxWidth === undefined && document.body.clientWidth < settings.unslickBreakpointMinWidth ) || document.body.clientWidth >= settings.unslickBreakpointMaxWidth ) ) {
					slickDisabled();
				} else if( !slider.hasClass('slick-initialized') ) {
					slider.addClass('carousel-slick-is_disabled');
					slider.parent().addClass('carousel-slick-wrapper-is_disabled');
				}
			}

			function slickDisabled() {
				slider.slick('unslick');
				slider.addClass('carousel-slick-is_disabled');
				slider.parent().addClass('carousel-slick-wrapper-is_disabled');
			}

			slickEnabled();

			$(window).on('resize', _.throttle(slickEnabled, 200));
			$(window).on('resize', _.throttle(productTileSlick, 200));
			//$(window).on('resize', _.throttle(timeSlotNav, 200));
		});
	};

	$('.cart-setup-sm__step-two__calendar__days').slick({
		adaptiveHeight: true,
		infinite: false,
		draggable: false,
		speed: 300,
		nextArrow: '.cart-setup-sm__step-two__calendar__control.next',
		prevArrow: '.cart-setup-sm__step-two__calendar__control.previous'
	});
})(jQuery);

function productTileSlickPlusBanner () {
	$('.withleftmenu .pt-slick-with-banner').not('.slick-initialized').slick({
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 2,
		slidesToScroll: 2,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 860,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.pt-slick-with-banner').not('.slick-initialized').slick({
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 3,
		slidesToScroll: 3,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 860,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});
}

function productTileSlick () {
	$('.withleftmenu .product-tile-slick, .cart--left .product-tile-slick').not('.slick-initialized').slick({
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 3,
		slidesToScroll: 3,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 860,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.pt-slick-small').not('.slick-initialized').slick({
		dots: true,
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 2,
		slidesToScroll: 2,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: true,
					draggable: true,
					swipe: true,
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 980,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 2.1,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.pt-slick').not('.slick-initialized').slick({
		dots: true,
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 3,
		slidesToScroll: 3,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 980,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 2.1,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});
}

function productTileSlickFbt () {
	$('.withleftmenu .product-tile-slick, .cart--left .product-tile-slick').not('.slick-initialized').slick({
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 5,
		slidesToScroll: 5,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 860,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.pt-slick-small').not('.slick-initialized').slick({
		dots: true,
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 5,
		slidesToScroll: 5,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: true,
					draggable: true,
					swipe: true,
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 980,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 2.1,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});

	$('.pt-slick').not('.slick-initialized').slick({
		dots: true,
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 5,
		slidesToScroll: 5,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 980,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 2.1,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});
}

function flyerTileSlick () {
	$('.flyer-slick-tiles').not('.slick-initialized').slick({
		dots: true,
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',		slidesToShow: 2,
		slidesToScroll: 2,
		draggable: false,
		swipe: false,
		infinite: false,
		responsive: [
			{
				breakpoint: 980,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 2.1,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1.1,
					slidesToScroll: 1
				}
			}
		]
	});
}

function cartSlick () {
	$('.couponsListSlick, .cartCarousel').not('.slick-initialized').slick({
		dots: true,
		arrows: false,
		slidesToShow: 2.4,
		slidesToScroll: 2,
		draggable: true,
		swipe: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 2,
					slidesToScroll: 2
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
}

function accountOverviewDiscountCouponsSlick() {
	// Carrousel slider options
	$('.slider-discount').slick({
		prevArrow: $('.prev'),
		nextArrow: $('.next'),
		centerMode: false,
		centerPadding: 5,
		slidesToShow: 1,
		infinite: true,
		dots: true,
	});
}

function templateSlick(elm, mobileSlideShow, tabletSlideShow, desktopSlideShow, insertTile) {
	let $slider = $(elm).not('.slick-initialized');
	let screenWidth = $(window).width();
	if (insertTile) {
		if (screenWidth >= 980) {
			let $emptyTile = $('<div />', {'class': 'tile--empty'});
			$($emptyTile).insertBefore(insertTile);
		}
	}

	$slider.slick({
		dots: true,
		prevArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-prev"><img src="/magasiner/images/icon/actions/icon-arrow-left.svg" alt=""><span class="invisible-text">' + sliderText.prev + '</span></button>',
		nextArrow: '<button type="button" class="pag-nav-btn slick-arrow slick-next"><img src="/magasiner/images/icon/actions/icon-arrow-right.svg" alt=""><span class="invisible-text">' + sliderText.next + '</span></button>',
		slidesToShow: desktopSlideShow,
		slidesToScroll: desktopSlideShow,
		draggable: true,
		swipe: true,
		infinite: false,
		accessibility: false,
		responsive: [
			{
				breakpoint: 980,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: tabletSlideShow,
					slidesToScroll: tabletSlideShow
				}
			},
			{
				breakpoint: 730,
				settings: {
					arrows: false,
					draggable: true,
					swipe: true,
					slidesToShow: mobileSlideShow,
					slidesToScroll: mobileSlideShow,
				},
			}
		]
	});

	$slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
		tabindexProductPricingGestion();
	});
	elm.addClass('active-carousel');
	tabindexProductPricingGestion();
}
function tabindexProductPricingGestion() {
	$('.pt__carousel .slick-slide').each(function () {
		let $this = $(this);
		if ($this.hasClass('slick-active')) {
			$this.children('div').attr('tabindex', 0);
			$this.find('.content__pricing').attr('tabindex', 0);
		} else {
			$this.children('div').attr('tabindex', -1);
			$this.find('.content__pricing').attr('tabindex', -1);

		}
	});
}